import { makeStyles } from '@material-ui/styles'
import type React from 'react'
import CodeBlock from 'core/components/CodeBlock'
import CopyToClipboard from 'core/components/CopyToClipboard'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import Text from 'core/elements/Text'
import type Theme from 'core/themes/model'

interface VmCredentialsPanelProps {
  vmPassword?: string
  // Only Windows VMs have an admin password worth showing. Defaults to true (today's
  // behavior) — callers that know the VM's OS (e.g. Clone VM) pass this explicitly.
  showCredentials?: boolean
}

const useStyles = makeStyles<Theme>((theme) => ({
  successIcon: {
    color: theme.palette.green['700-opaque'],
    marginRight: theme.spacing(1),
  },
  credentials: {
    display: 'grid',
    gap: theme.spacing(1),
    gridTemplateColumns: '1fr 6fr',
    alignItems: 'center',
  },
}))

const VmCredentialsPanel: React.FC<VmCredentialsPanelProps> = ({
  vmPassword,
  showCredentials = true,
}) => {
  const classes = useStyles()

  return (
    <>
      <Text variant="subtitle2">
        <FontAwesomeIcon solid className={classes.successIcon}>
          circle-check
        </FontAwesomeIcon>
        Congratulations! Your VM has been scheduled for creation
      </Text>

      {showCredentials && (
        <>
          <div>
            <Text variant="body2">
              This is a <b>Windows VM</b>. Use the credentials below to log in. Copy the password
              now, as you will not be able to view it again after you close this wizard.
            </Text>
          </div>

          <div className={classes.credentials}>
            <Text component="div" variant="body2">
              Windows Username:
            </Text>
            <CopyToClipboard copyText="Admin">
              <CodeBlock>
                <Text variant="body2" component="span">
                  Admin
                </Text>
              </CodeBlock>
            </CopyToClipboard>

            <Text component="div" variant="body2">
              Password:
            </Text>
            <CopyToClipboard copyText={vmPassword || ''}>
              <CodeBlock>
                <Text variant="body2" component="span">
                  {vmPassword}
                </Text>
              </CodeBlock>
            </CopyToClipboard>
          </div>
        </>
      )}
    </>
  )
}

export default VmCredentialsPanel
